import { render, staticRenderFns } from "./popup-stock.vue?vue&type=template&id=7f6507a2"
import script from "./popup-stock.vue?vue&type=script&lang=js"
export * from "./popup-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports